import { req } from './axiosFun';
import { tsreq } from './axiosFun';
/**
 * 权限接口
 **/
// 获取管理员
export const userAdminList  = (params) => { return req("get", "/manager/admin/userAdminList", params) };
// 新增编辑管理员
export const addEditUserAdmin  = (params) => { return tsreq("post", "/manager/admin/addEditUserAdmin ", params) };

// 删除管理员
export const delUserAdmin = (params) => { return req("get", "/manager/admin/delUserAdmin", params) };


// 获取所有角色
export const roleList  = (params) => { return req("get", "/manager/admin/roleList", params) };
// 新增编辑角色
export const addEditRole  = (params) => { return tsreq("post", "/manager/admin/addEditRole", params) };

// 删除角色
export const delRole = (params) => { return req("get", "/manager/admin/delRole", params) };

// 获取所有菜单 authMenuList
export const authMenuList  = (params) => { return req("get", "/manager/admin/authMenuList", params) };

// 新增编辑菜单
export const addEditAuthMenu  = (params) => { return tsreq("post", "/manager/admin/addEditAuthMenu", params) };

// 删除菜单
export const delAuthMenu  = (params) => { return req("get", "/manager/admin/delAuthMenu", params) };

//获取所有操作权限
export const authFunctionList  = (params) => { return req("get", "/manager/admin/authFunctionList", params) };

// 新增编辑操作权限
export const addEditAuthFunction  = (params) => { return tsreq("post", "/manager/admin/addEditAuthFunction", params) };

// 删除操作权限
export const delAuthFunction  = (params) => { return req("get", "/manager/admin/delAuthFunction", params) };

//配置角色菜单权限
export const configureRoleMenus  = (params) => { return req("get", "/manager/admin/configureRoleMenus", params) };

// 配置角色操作权限
export const configureRoleAuthFunction  = (params) => { return req("get", "/manager/admin/configureRoleAuthFunction", params) };

// 查询用户角色
export const getUserRoles  = (params) => { return req("get", "/manager/admin/getUserRoles", params) };

// 查询角色菜单权限
export const getRoleMemus  = (params) => { return req("get", "/manager/admin/getRoleMemus", params) };

// 查询角色操作权限
export const getRoleAuthFunctions  = (params) => { return req("get", "/manager/admin/getRoleAuthFunctions", params) };

export const getUserMenu =  (params)=>{return  req("get", "/manager/admin/getUserMenu", params)}

export const getPermissionIdByRole =  (params)=>{return  req("get", "/manager/admin/getPermissionIdByRole", params)}
